module.exports = __webpack_public_path__ + "static/img/inverter.ad206b2c.svg";